import { configureStore } from '@reduxjs/toolkit';
import { registerPatientSlice } from './slices/registerPatient/registerPatientSlice';
import { selfEnrollmentSlice } from './slices/selfEnrollment/selfEnrollmentSlice';

export const store = configureStore({
    reducer: {
        registerPatient: registerPatientSlice.reducer,
        selfEnrollment: selfEnrollmentSlice.reducer,
    }
})